import {
  ReportComponentOverlayMode,
  ReportLabelMode,
  ReportOverlayMode,
} from '@asset-viz/reporting/reportHeatmap'

export const getSectionHeatmapOverlayOptions = () => ({
  includeComponentOverlay: true,
  includeWeldOverlays: false,
  includeOverlay: true,
  componentOverlayMode: ReportComponentOverlayMode.Full,
  overlayMode: ReportOverlayMode.Embedded,
  labelMode: ReportLabelMode.All,
  includeSectionLabels: false,
})
